export const USER_WORKING_STATUS = [
  { label: 'Đang làm việc', value: 0, key: 'WORKING', className: 'status-success' },
  { label: 'Đã nghỉ việc', value: 1, key: 'RESIGNED', className: 'status-error' },
];
